export const PRODUCTS = {
  EXPLORER_ROUTE: "/products/explorer",
  SHEETS_ROUTE: "/products/sheets",
  API_ROUTE: "/products/api",
  STUDIO_ROUTE: "/products/studio",
}
export const LISTING_PAGES = {
  APP_LISTING_ROUTE: "/get-listed/apps",
  CHAIN_LISTING_ROUTE: "/get-listed/chains",
}
export const PRICING_ROUTE = "/pricing"
export const RESEARCH_ROUTE = "/resources"
export const ABOUT_ROUTE = "/about"
export const CUSTOMERS_ROUTE = "/customers"
export const makeCustomersPageRoute = (slug: string) =>
  `${CUSTOMERS_ROUTE}/${slug}`
export const CONTACT_ROUTE = "/#contact"
export const PRIVACY_POLICY_ROUTE = "/privacy-policy"
export const TERMS_ROUTE = "/terms"

export const BASE_BLOG_PATH = "/resources"
